import { Breadcrumbs, ForwardBtn, ProjectCard } from "@components/shared";
import { homePortfolioPageData } from "@demo-data/portfolio";
import { Container } from "@mui/material";
import { Stack } from "@mui/system";
import "react-lazy-load-image-component/src/effects/blur.css";

export default function PortfolioPage() {
  return (
    <Container maxWidth="lg">
      <Stack gap={4}>
        <Breadcrumbs title="projects" description={"All of my projects"} />

        {homePortfolioPageData?.map((item, index) => {
          return (
            <Stack key={Math.random()} gap={4}>
              <ForwardBtn title={item?.results?.title} isShowBackBtn={false} />
              <ProjectCard key={index} data={item.results.data} />
            </Stack>
          );
        })}
      </Stack>
    </Container>
  );
}
